/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Rolename1Inputs */

const en_entity_rolename1 = /** @type {(inputs: Entity_Rolename1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role Name`)
};

const de_entity_rolename1 = /** @type {(inputs: Entity_Rolename1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

/**
* | output |
* | --- |
* | "Role Name" |
*
* @param {Entity_Rolename1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_rolename1 = /** @type {((inputs?: Entity_Rolename1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Rolename1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_rolename1(inputs)
	return de_entity_rolename1(inputs)
});
export { entity_rolename1 as "entity_roleName" }